<!-- 备案查询 -->
<template>
  <div class="container">
    <!-- <div>备案规则：XXXXXXXXXXX待业务提供文案后补充</div> -->
    <div>
      <!-- 搜索 -->
      <div style="margin-top: 10px">
        <e-search
          :data="listQuery"
          :field-list="fieldList"
          :list-type-info="listTypeInfo"
          @handleFilter="handleFilter"
          @handleReset="handleReset"
          :count="7"
        ></e-search>
      </div>

      <div class="handle-wrapper">
        <eui-btn @click="launchVisible = true"> 发起申请 </eui-btn>
      </div>

      <el-tabs
        :stretch="true"
        v-model="activeName"
        type="card"
        @tab-click="handleActiveName"
      >
        <el-tab-pane
          v-for="item in tabLabel"
          :key="item.name"
          :name="item.name"
        >
          <span slot="label">{{ item.label }}</span>
        </el-tab-pane>
      </el-tabs>

      <tableList
        :loading="tableLoading"
        ref="table"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template #inquiryOverdueDaysHeader>
          <span>询比价/招标超期</span>
          <el-tooltip class="item" effect="dark" placement="top-end">
            <div slot="content">
              本次备案成功后，客户连续未开展询比价或自行招标业务的天数
            </div>
            <div class="icon-question">?</div>
          </el-tooltip>
        </template>
        <template #orgSetOverdueDaysHeader>
          <span>组织机构配置逾期</span>
          <el-tooltip class="item" effect="dark" placement="top-end">
            <div slot="content">本次备案成功后，客户未配置组织机构的天数</div>
            <div class="icon-question">?</div>
          </el-tooltip>
        </template>
        <template #orderAmountHeader>
          <span>易资源订单总金额</span>
          <el-tooltip class="item" effect="dark" placement="top-end">
            <div slot="content">本次备案成功后，客户创建的易资源订单总金额</div>
            <div class="icon-question">?</div>
          </el-tooltip>
        </template>
        <template #inquiryOverdueDays="{ scope }">
          <span
            :style="{
              color: scope.row.inquiryOverdueDays >= 90 ? '#E50113' : '',
            }"
            >{{ scope.row.inquiryOverdueDays }}</span
          >
        </template>
        <template #orgSetOverdueDays="{ scope }">
          <!-- 天数>=15天为逾期 -->
          <span
            :style="{
              color: scope.row.orgSetOverdueDays >= 15 ? '#E50113' : '',
            }"
            >{{ scope.row.orgSetOverdueDays }}</span
          >
        </template>
        <template #orderAmount="{ scope }">
          <span
            :style="{ color: scope.row.orderAmount === 0 ? '#E50113' : '' }"
            >{{ scope.row.orderAmount }}</span
          >
        </template>
        <template #orgSetting="{ scope }">
          <span>{{ getOrgSetting(scope.row.orgSetting) }}</span>
        </template>
        <template #openEpecPurchase="{ scope }">
          <span>{{ getOpenEpecPurchase(scope.row.openEpecPurchase) }}</span>
        </template>
        <template #corporateCreditGrade="{ scope }">
          <span>{{
            getCorporateCreditGrade(scope.row.corporateCreditGrade)
          }}</span>
        </template>
        <template #handle="{ scope }">
          <el-button
            type="link"
            font-size="12px"
            @click="handleApply(scope.row)"
            >申请备案</el-button
          >
        </template>
        <template #charge="{ scope }">
          <eui-btn
            type="link"
            font-size="12px"
            @click="openChargeDialog(scope.row)"
          >
            查看收费策略
          </eui-btn>
        </template>
      </tableList>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :page-size="listQuery.pageSize"
          :total="total"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>

    <ApplyDialog
      v-if="applyVisible"
      :applyVisible.sync="applyVisible"
      :applyForm="applyForm"
      @refresh="refresh"
      :auditData="auditData"
    />

    <ChargeDialog
      :chargeVisible.sync="chargeVisible"
      v-if="chargeVisible"
      :auditData="auditData"
    />

    <LaunchDialog :launchVisible.sync="launchVisible"></LaunchDialog>
  </div>
</template>

<script>
import TableList from '@/modules/projectA/components/common/e-table-list';
import ESearch from '@/modules/projectA/components/common/e-search';

import ApplyDialog from './components/applyDialog.vue';
import ChargeDialog from './components/chargeDialog.vue';
import LaunchDialog from './components/launchDialog.vue';

import Api from '@/modules/projectA/api/filing';
import mixins from './components/mixins';
export default {
  mixins: [mixins],
  components: {
    ESearch,
    TableList,
    ApplyDialog,
    ChargeDialog,
    LaunchDialog,
  },
  data() {
    return {
      launchVisible: false,
      auditData: {},
      applyForm: {},
      tabLabel: [
        { label: '已备案', name: '1' },
        { label: '审核中', name: '2' },
        { label: '审核拒绝', name: '3' },
        { label: '公示中', name: '4' },
        { label: '已解除', name: '5' },
      ],
      activeName: '1',
      submitForm: {
        name: '',
      },
      dialogTitle: '申请备案',
      fieldList: [
        {
          label: '客户名称',
          type: 'input',
          value: 'resourceCompanyName',
        },
        {
          label: '备案状态',
          type: 'select',
          value: 'filingStatus',
          list: 'filingStatusList',
        },
        {
          label: '组织机构配置',
          type: 'select',
          value: 'orgSetting',
          list: 'orgSettingList',
        },
        {
          label: '是否开通易专采',
          type: 'select',
          value: 'openEpecPurchase',
          list: 'openEpecPurchaseList',
        },
        {
          label: '法人信用认证',
          type: 'select',
          value: 'corporateCreditGrade',
          list: 'corporateCreditGradeList',
        },
        { label: '行业', type: 'input', value: 'industry' },
      ],
      tableLoading: false,

      listQuery: {
        pageNum: 1,
        pageSize: 10,
        resourceCompanyName: '',
        filingStatus: '',
        filingCompanyName: '',
        orgSetting: '',
        openEpecPurchase: '',
        corporateCreditGrade: '',
        industry: '',
        filingType: 2,
        pageView: 2,
      },
      cloneListQuery: {},
      total: 0,
      tableData: [],
      tableLabel: [
        {
          label: '客户名称',
          param: 'resourceCompanyName',
          align: 'center',
          minWidth: '200px',
          fixed: 'left',
        },
        {
          label: '组织机构配置',
          param: 'orgSetting',
          align: 'center',
          slot: 'orgSetting',
          minWidth: '150px',
        },
        {
          label: '组织机构数量',
          param: 'orgCount',
          align: 'center',
          minWidth: '150px',
        },
        {
          label: '是否开通易专采',
          param: 'openEpecPurchase',
          align: 'center',
          slot: 'openEpecPurchase',
          minWidth: '150px',
        },
        {
          label: '法人信用认证等级',
          param: 'corporateCreditGrade',
          align: 'center',
          slot: 'corporateCreditGrade',
          minWidth: '150px',
        },
        {
          label: '行业',
          param: 'industry',
          align: 'center',
          minWidth: '180px',
        },
        {
          label: '操作',
          align: 'center',
          width: '130',
          slot: 'charge',
          fixed: 'right',
        },
      ],
      baseTableLabel: [],
      labelObj: {
        1: [
          {
            label: '备案方',
            param: 'filingCompanyName',
            align: 'center',
            minWidth: '200px',
          },
          {
            label: 'orgSetOverdueDaysHeader',
            param: 'orgSetOverdueDays',
            align: 'center',
            header: true,
            slot: 'orgSetOverdueDays',
            width: '150px',
          },
          {
            label: 'inquiryOverdueDaysHeader', // 询比价/招标超期 本次备案成功后，客户连续未开展询比价或自行招标业务的天数
            param: 'inquiryOverdueDays',
            align: 'center',
            header: true,
            slot: 'inquiryOverdueDays',
            width: '150px',
          },
          {
            label: 'orderAmountHeader', // 询比价/招标超期 本次备案成功后，客户连续未开展询比价或自行招标业务的天数
            param: 'orderAmount',
            align: 'center',
            header: true,
            slot: 'orderAmount',
            width: '150px',
          },
          // 易资源订单总金额
          /* {
            label: '询比价/招标超期',
            param: 'inquiryOverdueDays',
            align: 'center',
          }, */
        ],
        2: [
          {
            label: '备案状态',
            param: 'filingStatusDesc',
            align: 'center',
          },
          {
            label: '备案方',
            param: 'filingCompanyName',
            align: 'center',
            minWidth: '200px',
          },
        ],
        3: [
          {
            label: '备案状态',
            param: 'filingStatusDesc',
            align: 'center',
          },
          {
            label: '审核意见',
            param: 'reason',
            align: 'center',
          },
        ],
        4: [
          {
            label: '备案状态',
            param: 'filingStatusDesc',
            align: 'center',
          },
          {
            label: '备案方',
            param: 'filingCompanyName',
            align: 'center',
            minWidth: '200px',
          },
        ],
        5: [
          {
            label: '解除原因',
            param: 'reason',
            align: 'center',
            minWidth: '200px',
          },
        ],
      },
      applyVisible: false,
      chargeVisible: false,
      tabQueryReady: {},
    };
  },
  mounted() {
    console.log(this.$options.data(), 'this.$options.data().listQuery;');
    this.baseTableLabel = this.$options.data().tableLabel;
    console.log(this.baseTableLabel, 'this.baseTableLabel');
    this.cloneListQuery = this.$options.data().listQuery;
    this.tabStatus('1');
    // this.getList(this.listQuery);
  },
  methods: {
    openChargeDialog(row) {
      this.chargeVisible = true;
      this.auditData = { ...row, isShow: false };
    },
    tabStatus(status) {
      this.tableLabel = [...this.baseTableLabel];
      console.log(this.tableLabel, 'this.tableLabel');
      this.listQuery.pageView = 2;
      const tableRef = this.$refs.table.$refs.table;
      this.tableData = [];
      this.tabQueryReady = {};
      switch (status) {
        case '1': // 已备案
          this.tableLabel.splice(1, 0, ...this.labelObj[status]);
          tableRef.doLayout();

          this.tabQueryReady = {
            filingStatus: 2,
            auditStatusList: [],
            pageView: 2,
            auditStatus: '',
          };
          this.listQuery = { ...this.listQuery, ...this.tabQueryReady };
          this.getList(this.listQuery);
          break;
        case '2': // 审核中
          this.tableLabel.splice(1, 0, ...this.labelObj[status]); //.pop();
          this.tableLabel.pop();
          tableRef.doLayout();

          this.tabQueryReady = {
            auditStatusList: [1, 2],
            pageView: 2,
            filingStatus: '',
            auditStatus: '1,2',
          };
          this.listQuery = { ...this.listQuery, ...this.tabQueryReady };
          this.getList(this.listQuery);
          break;
        case '3': // 审核拒绝
          this.tableLabel.splice(1, 0, ...this.labelObj[status]);
          this.tableLabel.pop();
          this.tableLabel.push({
            label: '操作',
            align: 'center',
            width: '130',
            slot: 'handle',
            fixed: 'right',
          });
          tableRef.doLayout();

          this.tabQueryReady = {
            auditStatusList: [3, 5],
            auditStatus: '3,5',
            filingStatus: '',
            pageView: 2,
          };
          this.listQuery = { ...this.listQuery, ...this.tabQueryReady };
          this.getList(this.listQuery);
          break;
        case '4': // 公示中
          this.tableLabel.splice(1, 0, ...this.labelObj[status]);
          this.tableLabel.pop();
          this.tableLabel.push({
            label: '操作',
            align: 'center',
            width: '130',
            slot: 'handle',
            fixed: 'right',
          });
          tableRef.doLayout();

          this.tabQueryReady = {
            filingStatus: 1,
            pageView: 1,
            auditStatusList: [],
            auditStatus: '',
          };
          this.listQuery = { ...this.listQuery, ...this.tabQueryReady };
          this.getList(this.listQuery);
          break;
        case '5': // 已解除
          this.tableLabel.splice(1, 0, ...this.labelObj[status]);
          this.tableLabel.pop();
          this.tableLabel.push({
            label: '操作',
            align: 'center',
            width: '130',
            slot: 'handle',
            fixed: 'right',
          });
          tableRef.doLayout();

          this.tabQueryReady = {
            auditStatusList: [6],
            auditStatus: '6',
            filingStatus: '',
            pageView: 2,
          };

          this.listQuery = { ...this.listQuery, ...this.tabQueryReady };
          this.getList(this.listQuery);
          break;
        default:
          this.tableLabel.splice(1, 0, ...this.labelObj[status]);
      }
    },
    handleActiveName(active) {
      console.log(active.name);
      this.tabStatus(active.name);
      /* {
          label: '备案方',
          param: 'purchaseButler',
          align: 'center',
        }, */
    },
    async handleApply(row) {
      const { resourceId } = row;
      const result = await Api.checkFilingApply({ resourceId });
      if (result.code === '200') {
        this.applyForm = { ...row, ...result.data, filingType: 1 };
        console.log(result.data, this.applyForm, 'this.applyForm ');
        this.applyVisible = true;
      }
    },
    refresh() {
      this.getList(this.listQuery);
    },
    // 获取数据
    async getList(params) {
      try {
        this.tableData = [];
        this.tableLoading = true;
        const result = await Api.queryFilingResourcePage(params);
        if (result.code === '200') {
          const data = result.data;
          this.tableData = [...data.records];
          this.total = data.total;
        }
      } finally {
        this.tableLoading = false;
      }
    },

    // 返回上一页
    handleGoBack() {
      this.$router.go(-1);
    },

    // 查询
    handleFilter(val) {
      console.log(val, '查询val');
      if (this.activeName === '2' || this.activeName === '3') {
        this.listQuery = {
          ...val,
          ...this.tabQueryReady,
          pageNum: 1,
          filingStatus: val.filingStatus,
        };
      } else {
        this.listQuery = { ...val, ...this.tabQueryReady, pageNum: 1 };
      }
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery, ...this.tabQueryReady };
      this.getList(this.listQuery);
    },

    // 分页
    handleSizeChange(size) {
      this.listQuery.pageSize = size;
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },

    handleCurrentChange(page) {
      this.listQuery.pageNum = page;
      this.getList(this.listQuery);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .icon-question {
  height: 18px;
  width: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #c5c5c5;
  color: #c5c5c5;
  display: inline-block;
  margin-left: 10px;
}
</style>
